import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface Item3DescriptionProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Item3Description: React.FC<Item3DescriptionProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [item3, set_item3] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Expand Primary Structure']?.['Item #3']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Expand Primary Structure': { ...b.values?.['Expand Primary Structure'], 'Item #3': [v, b.values?.['Expand Primary Structure']?.['Item #3']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={item3}
                />
            ) : (
                <TextBox
                    value={item3}
                    onChange={(value) => set_item3(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
